import { render, staticRenderFns } from "./ModalCriarPastas.vue?vue&type=template&id=4e447b47&"
import script from "./ModalCriarPastas.vue?vue&type=script&lang=js&"
export * from "./ModalCriarPastas.vue?vue&type=script&lang=js&"
import style0 from "./ModalCriarPastas.vue?vue&type=style&index=0&id=4e447b47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports